const QUOTER_CONFIG = {
  iva: 1.16,
  moneda: "MXN",
  simbolo: "$",
  materialActivo: "premium",
  margenesPorVolumen: [
    { min: 25, max: 49, margen: 5 },
    { min: 50, max: 99, margen: 4.5 },
    { min: 100, max: 199, margen: 4 },
    { min: 200, max: 499, margen: 3.5 },
    { min: 500, max: 999, margen: 3 },
    { min: 1e3, max: 1e5, margen: 2 },
  ],
  materiales: {
    premium: {
      id: "premium",
      nombre: "Sticker Premium",
      descripcion: "Acabado glossy, resistente al agua",
      costFactor: 0.04109,
      habilitado: !0,
    },
    holografico: {
      id: "holografico",
      nombre: "Sticker Hologr\xE1fico",
      descripcion: "Efecto hologr\xE1fico brillante premium",
      costFactor: 0.04109,
      habilitado: !0,
    },
    economico: {
      id: "economico",
      nombre: "Sticker Econ\xF3mico",
      descripcion: "La opci\xF3n m\xE1s accesible, sin laminado",
      costFactor: 0.02433,
      habilitado: !0,
    },
    iman: {
      id: "iman",
      nombre: "Im\xE1n Impreso",
      descripcion: "Im\xE1n flexible de alta calidad para nevera",
      costFactor: 0.12,
      habilitado: !0,
    },
    sheets: {
      id: "sheets",
      nombre: "Sticker Sheets Laminadas",
      descripcion: "Varios dise\xF1os en una l\xE1mina, laminado incluido",
      costFactor: 0.04109,
      habilitado: !0,
    },
    sheets_economicas: {
      id: "sheets_economicas",
      nombre: "Sticker Sheets Econ\xF3micas",
      descripcion: "Varios dise\xF1os en una l\xE1mina, sin laminado",
      costFactor: 0.02433,
      habilitado: !0,
    },
  },
  limites: {
    anchoMin: 4,
    anchoMax: 40,
    altoMin: 4,
    altoMax: 100,
    incremento: 0.5,
    cantidadMin: 25,
    cantidadMax: 1e5,
  },
  // Solo informativo (hints de UI). El cobro real de envío es server-side.
  // Paridad baked: avexrh-api/src/config/limits.js → LIMITS.shipping.
  envio: {
    costo: 170,
    gratisDesde: 3000,
  },
  getMaterialIdByHandle(i) {
    return (
      {
        vinil: "premium",
        holografico: "holografico",
        imanes: "iman",
        "iman-impreso": "iman",
        economicos: "economico",
        "sheets-laminadas": "sheets",
        "sheets-economicas": "sheets_economicas",
      }[i] || "premium"
    );
  },
  getConfigByHandle(i) {
    const a = this.getMaterialIdByHandle(i);
    return this.materiales[a];
  },
  detectProductHandle() {
    if (typeof window > "u") return null;
    const i = window.location.pathname.match(/\/(?:products|pages)\/([^/?#]+)/);
    return i ? i[1] : null;
  },
  normalizeProductId(i) {
    if (!i) return "premium";
    const a = i.toLowerCase().trim();
    return (
      {
        holo: "holografico",
        vinil: "premium",
        vinyl: "premium",
        premium: "premium",
        "sticker premium": "premium",
        imán: "iman",
        "iman flexible": "iman",
        "sticker econ\xF3mico": "economico",
        "sticker economico": "economico",
        "sheets laminadas": "sheets",
        "sheets adhesivas": "sheets",
        "sheets econ\xF3micas": "sheets_economicas",
        "sheets economicas": "sheets_economicas",
        "sticker sheets econ\xF3micas": "sheets_economicas",
        "sticker sheets economicas": "sheets_economicas",
      }[a] || a
    );
  },
  initDynamicConfig() {
    const i = this.detectProductHandle();
    if (i) {
      const a = this.getMaterialIdByHandle(i);
      ((this.materialActivo = a),
        window.QUOTER_DEBUG &&
          console.log(
            `[Quoter Config] Producto detectado: ${i} \u2192 Material: ${a}`,
          ));
    }
    return this;
  },
  hydrate(apiData) {
    try {
      const cfg =
        apiData && apiData.data && typeof apiData.data === "object"
          ? apiData.data
          : apiData;
      if (!cfg || typeof cfg !== "object") return this;
      const isNum = (v) => typeof v === "number" && isFinite(v);
      if (cfg.limits && cfg.limits.tax && isNum(cfg.limits.tax.rate))
        this.iva = 1 + cfg.limits.tax.rate;
      if (Array.isArray(cfg.margins))
        cfg.margins.forEach((m) => {
          if (!m || !isNum(m.min) || !isNum(m.max) || !isNum(m.margin)) return;
          const tier = this.margenesPorVolumen.find(
            (t) => t.min === m.min && t.max === m.max,
          );
          if (tier) tier.margen = m.margin;
        });
      if (Array.isArray(cfg.products))
        cfg.products.forEach((raw_p) => {
          if (!raw_p || typeof raw_p.id !== "string" || !isNum(raw_p.factorCosto)) return;
          // Alias legacy: un worker pre-migración (ago 2026) manda id 'vinyl'.
          const p = raw_p.id === "vinyl" ? { ...raw_p, id: "premium" } : raw_p;
          const base = this.materiales[p.id] || { id: p.id };
          // Márgenes propios del material (override del panel). Si el API no
          // los manda, el objeto se reconstruye sin `margenes` y el material
          // vuelve a heredar la tabla global (margenesPorVolumen).
          const margenes = Array.isArray(p.margins)
            ? p.margins
                .filter((m) => m && isNum(m.min) && isNum(m.max) && isNum(m.margin))
                .map((m) => ({ min: m.min, max: m.max, margen: m.margin }))
            : [];
          this.materiales[p.id] = {
            ...(margenes.length ? { margenes } : {}),
            id: p.id,
            nombre:
              typeof p.nombre === "string" && p.nombre
                ? p.nombre
                : base.nombre || p.id,
            descripcion:
              typeof p.descripcion === "string" && p.descripcion
                ? p.descripcion
                : base.descripcion || "",
            costFactor: p.factorCosto,
            habilitado:
              typeof p.activo === "boolean"
                ? p.activo
                : base.habilitado !== undefined
                  ? base.habilitado
                  : !0,
          };
        });
      if (cfg.limits) {
        const dim = cfg.limits.dimensions,
          qty = cfg.limits.quantity,
          L = this.limites;
        if (dim) {
          if (isNum(dim.minWidth)) L.anchoMin = dim.minWidth;
          if (isNum(dim.maxWidth)) L.anchoMax = dim.maxWidth;
          if (isNum(dim.minHeight)) L.altoMin = dim.minHeight;
          if (isNum(dim.maxHeight)) L.altoMax = dim.maxHeight;
          if (isNum(dim.increment)) L.incremento = dim.increment;
        }
        if (qty) {
          if (isNum(qty.min)) L.cantidadMin = qty.min;
          if (isNum(qty.max)) L.cantidadMax = qty.max;
        }
        const ship = cfg.limits.shipping;
        if (ship) {
          if (isNum(ship.standardCost)) this.envio.costo = ship.standardCost;
          if (isNum(ship.freeThreshold)) this.envio.gratisDesde = ship.freeThreshold;
        }
      }
    } catch (e) {
      typeof console < "u" &&
        console.warn &&
        console.warn(
          "[Quoter Config] hydrate fall\xF3, se conservan valores baked:",
          e,
        );
    }
    return this;
  },
  loadFromCacheAndApi() {
    try {
      if (typeof localStorage < "u") {
        const raw = localStorage.getItem("quoter_api_config");
        if (raw) this.hydrate(JSON.parse(raw));
      }
    } catch (e) {
      typeof console < "u" &&
        console.warn &&
        console.warn("[Quoter Config] cache local inv\xE1lida:", e);
    }
    const fetchConfig = () => {
      if (
        typeof window > "u" ||
        !window.AvexrhAPI ||
        typeof window.AvexrhAPI.getConfig !== "function"
      )
        return !1;
      window.AvexrhAPI.getConfig()
        .then((data) => {
          (this.hydrate(data),
            (() => {
              try {
                typeof localStorage < "u" &&
                  localStorage.setItem(
                    "quoter_api_config",
                    JSON.stringify(data),
                  );
              } catch (e) {}
            })(),
            typeof document < "u" &&
              typeof CustomEvent === "function" &&
              document.dispatchEvent(new CustomEvent("quoter:config-updated")));
        })
        .catch((err) => {
          typeof console < "u" &&
            console.warn &&
            console.warn(
              "[Quoter Config] no se pudo refrescar /api/config, se usan baked/cache:",
              err && err.message ? err.message : err,
            );
        });
      return !0;
    };
    if (!fetchConfig()) {
      let done = !1,
        attempts = 0;
      const tryOnce = () => {
        if (done) return;
        if (fetchConfig()) {
          done = !0;
          return;
        }
        ++attempts <= 40 && setTimeout(tryOnce, 250);
      };
      (typeof window < "u" &&
        typeof window.addEventListener === "function" &&
        window.addEventListener("load", tryOnce, { once: !0 }),
        setTimeout(tryOnce, 250));
    }
    return this;
  },
};
typeof window < "u" &&
  ((window.QUOTER_CONFIG = QUOTER_CONFIG),
  QUOTER_CONFIG.initDynamicConfig(),
  QUOTER_CONFIG.loadFromCacheAndApi());
